import React from 'react';
import { FlagGroup } from '@atlaskit/flag';
import { FlagListProps } from './FlagTypes';

const FlagList: React.FC<FlagListProps> = ({
  flags,
  onDismiss,
  linkedEmail,
}) => (
  <FlagGroup>
    {flags.map((flag) => {
      const FlagComponent = flag.component;
      return (
        <FlagComponent
          key={flag.code}
          onDismiss={() => onDismiss(flag.code)}
          linkedEmail={linkedEmail}
        />
      );
    })}
  </FlagGroup>
);
export default FlagList;
